import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, NgModule } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { NgxsModule, select } from '@ngxs/store';
import { AnimateModule, BasicPage, HeaderComponent, NewsletterComponent, WwwRouteSlug } from '@pro-connect/shared';
import { ProEduTraInfoComponent } from './components/pro-edu-tra-info/pro-edu-tra-info.component';
import { ProEduTraTicComponent } from './components/pro-edu-tra-tic/pro-edu-tra-tic.component';
import { ProEduTraTopComponent } from './components/pro-edu-tra-top/pro-edu-tra-top.component';
import { ProEducationTrainingState, ProEducationTrainingStateGetTrainingDetails } from './pro-education-training.state';
import { OPINIONS } from 'shared/src/utils/const/opinions';
import { ProEduTraAgeComponent } from './components/pro-edu-tra-age/pro-edu-tra-age.component';
import { Angulartics2GoogleTagManager } from 'angulartics2';

@NgModule({
  imports: [NgxsModule.forFeature([ProEducationTrainingState])],
})
class ProEducationTrainingStateLazyModule {}

@Component({
  templateUrl: './pro-education-training.component.html',
  styleUrls: ['./pro-education-training.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterModule,
    AnimateModule,
    ProEducationTrainingStateLazyModule,
    HeaderComponent,
    NewsletterComponent,
    ProEduTraTopComponent,
    ProEduTraInfoComponent,
    ProEduTraTicComponent,
  ],
})
export class ProEducationTrainingComponent extends BasicPage {
  public override readonly loading = select(ProEducationTrainingState.loading);
  public readonly trainingDetails = select(ProEducationTrainingState.training);
  public readonly markedEvent = select(ProEducationTrainingState.markedEvent);
  public readonly WwwRouteSlug = WwwRouteSlug;
  public slug = '';
  public readonly tempReviews = OPINIONS;
  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _angulartics2GoogleTagManager = inject(Angulartics2GoogleTagManager);

  constructor() {
    super();
    this.slug = this._activatedRoute.snapshot.params['slug'];
    this._store.dispatch([new ProEducationTrainingStateGetTrainingDetails({ slug: this.slug })]);
  }

  public ngOnInit(): void {
    this._pushLayer();
  }

  private _pushLayer(): void {
    this._angulartics2GoogleTagManager.pushLayer({
      brand: 'LDB',
      language: 'pl',
      country: 'Pl',
      siteTypeLevel: this._isDevelopment ? 'test' : 'main',
      pageCategory: 'training',
      geoIPLocation: 'Pl',
      uiLoggedStatus: !!this.user() ? 'logged' : 'not logged',
      uiType: this.user()?.type,
    });
  }
}
